module.exports = {
      id: "login-usage",
      viewBox: "0 0 14.742 20.333",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#login",
      toString: function () {
        return this.url;
      }
    }